import { useMutation } from '@apollo/client';

import {
  ExportVsmeReportMutation,
  ExportVsmeReportMutationVariables,
  VsmeExportType,
} from '@/modules/common/types';

import { EXPORT_VSME_REPORT_MUTATION } from '../api/newReport.mutation';

interface ExportVsmeReportInput {
  reportId: string;
  projectId: string;
}

export const useExportVsmeReport = ({ reportId, projectId }: ExportVsmeReportInput) => {
  const [exportVsmeReportMutation, { loading, error }] = useMutation<
    ExportVsmeReportMutation,
    ExportVsmeReportMutationVariables
  >(EXPORT_VSME_REPORT_MUTATION);

  const exportVsmeReport = async (exportType: VsmeExportType = VsmeExportType.KPI_ONLY) => {
    try {
      const result = await exportVsmeReportMutation({
        variables: { input: { reportId, projectId, exportType } },
      });
      return result.data?.exportVsmeReport || null;
    } catch (err) {
      console.error('Failed to export VSME report:', err);
      return null;
    }
  };

  return {
    exportVsmeReport,
    loading,
    error,
  };
};

/**
 * Checks if a template name indicates a VSME template
 */
export const isVsmeTemplate = (templateName: string | null | undefined): boolean => {
  if (!templateName) return false;
  const lowerName = templateName.toLowerCase();
  return lowerName.startsWith('vsme') || lowerName.includes('vsme');
};
